/* eslint-disable max-len */
import React, { FC, useEffect, useState } from 'react'
import Modal from '../common/Modal'
import Holidays from 'date-holidays'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LoadingSquare from '../common/LoadingSquare'
import { useAlert } from 'react-alert'
import { IconName } from '@fortawesome/fontawesome-common-types'
import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'

interface Props {
  closeCallback: VoidFunction
  updateCallback: (displayType: string, displayRange: string, callback: VoidFunction) => void
  isDisplay: boolean
  isLoading?: boolean
}

const GanttUserSettingModal: FC<Props> = (props) => {
  const {
    closeCallback,
    updateCallback,
    isDisplay,
    isLoading,
  } = props

  const {
    current,
  } = useSelector((state: RootState) => state)

  const alert = useAlert()

  const holidays = new Holidays()
  holidays.init('JP')

  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false)

  const [displayType, setDisplayType] = useState<string>("project")
  const [rangeType, setRangeType] = useState<string>("daily")

  const closeModal = () => {
    closeCallback()
  }

  const submit = () => {
    setIsLoadingSubmit(true)
    updateCallback(
      displayType,
      rangeType,
      () => {
        closeCallback()
        setIsLoadingSubmit(false)
        alert.success("ガントチャートのユーザー設定を更新しました")
      },
    )
  }

  useEffect(() => {
    setDisplayType(current.taskGanttChartDisplayTypeInit)
    setRangeType(current.taskGanttChartRangeTypeInit)
  }, [])

  return (
    <Modal
      show={isDisplay}
      wrapperClass="gantt_modal w900"
      closeCallback={closeModal}
      closeable
    >
      <>
        {
          isLoading ? (
            <>
              <LoadingSquare>
                <>
                  設定を取得しています…
                </>
              </LoadingSquare>
            </>
          ) : (
            <>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  padding: "4px 8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  marginBottom: "16px",
                  color: "#666666",
                }}
              >
                ガントチャートのユーザー設定
              </div>
              <fieldset>
                <legend>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    ガントチャートの初期表示区分
                  </div>
                </legend>
                <div
                  className="item w100"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    marginBottom: "0",
                  }}
                >
                  <div
                    onClick={() => setDisplayType("category")}
                    role="none"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      cursor: "pointer",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={['far', `${displayType === "category" ? 'check-square' : 'square'}` as IconName]}
                      className={`icon ${displayType === "category" ? "checked" : "no_check"}`}
                      style={{
                        fontSize: "18px",
                        color: displayType === "category" ? "#08984C" : "#666666",
                      }}
                    />
                    <div>
                      <div className="check_box_title">
                        カテゴリー
                      </div>
                    </div>
                  </div>
                  <div
                    onClick={() => setDisplayType("project")}
                    role="none"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      cursor: "pointer",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={['far', `${displayType === "project" ? 'check-square' : 'square'}` as IconName]}
                      className={`icon ${displayType === "project" ? "checked" : "no_check"}`}
                      style={{
                        fontSize: "18px",
                        color: displayType === "project" ? "#08984C" : "#666666",
                      }}
                    />
                    <div>
                      <div className="check_box_title">
                        プロジェクト
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <legend>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    ガントチャートの初期表示期間
                  </div>
                </legend>
                <div
                  className="item w100"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    marginBottom: "0",
                  }}
                >
                  <div
                    onClick={() => setRangeType("daily")}
                    role="none"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      cursor: "pointer",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={['far', `${rangeType === "daily" ? 'check-square' : 'square'}` as IconName]}
                      className={`icon ${rangeType === "daily" ? "checked" : "no_check"}`}
                      style={{
                        fontSize: "18px",
                        color: rangeType === "daily" ? "#08984C" : "#666666",
                      }}
                    />
                    <div>
                      <div className="check_box_title">
                        日表示
                      </div>
                    </div>
                  </div>
                  <div
                    onClick={() => setRangeType("weekly")}
                    role="none"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      cursor: "pointer",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={['far', `${rangeType === "weekly" ? 'check-square' : 'square'}` as IconName]}
                      className={`icon ${rangeType === "weekly" ? "checked" : "no_check"}`}
                      style={{
                        fontSize: "18px",
                        color: rangeType === "weekly" ? "#08984C" : "#666666",
                      }}
                    />
                    <div>
                      <div className="check_box_title">
                        週表示
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
              <div className="button_area">
                <button
                  type="button"
                  className="button cancel"
                  onClick={() => closeCallback()}
                >
                  キャンセル
                </button>
                <button
                  type="button"
                  className="button"
                  onClick={submit}
                  disabled={isLoadingSubmit}
                >
                  {
                    isLoadingSubmit ? (
                      <>
                        <FontAwesomeIcon icon={['fas', 'spinner']} spin />
                      </>
                    ) : (
                      <>
                        更新
                      </>
                    )
                  }
                </button>
              </div>
            </>
          )
        }
      </>
    </Modal>
  )
}

GanttUserSettingModal.defaultProps = {
  isLoading: false,
}

export default GanttUserSettingModal
